// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__h5KOg","footer":"ModalCreateQualiphyProcedure_footer__ltMni","additionData":"ModalCreateQualiphyProcedure_additionData__39nGr"};